import ImageKit from "imagekit-javascript";
import config from "@/config";

export const imagekit = () =>
  new ImageKit({
    urlEndpoint: config("imageKitUrl"),
  });

export const getImageKitUrl = (path: string, options?: any) => {
  return imagekit().url({
    path,
    transformation: [
      {
        ...options,
      },
    ],
  });
};
